var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title" }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Прочитал\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-form",
        {
          ref: "form",
          staticClass: "vacancy-form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "div",
            { staticClass: "row mx-0 my-0" },
            [
              _vm._t("description", function () {
                return [
                  _c("div", { staticClass: "col-12 col-md-6 col-lg-6 p-md-2" }),
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-md-6 col-lg" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "vacancy-form__item" },
                        [
                          _c("v-text-field", {
                            staticClass: "vacancy-form__input",
                            attrs: {
                              readonly: !!_vm.jobPosition,
                              rules: [_vm.rules.required],
                              required: "",
                              id: "position",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                                    Предполагаемая должность *\n                                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.position,
                              callback: function ($$v) {
                                _vm.position = $$v
                              },
                              expression: "position",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-12 px-3 pt-3 mb-8 position-relative ",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "vacancy-form__item position-relative" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary  ",
                              class: {
                                "has-error": _vm.fileError,
                                "shake-animation": _vm.fileError,
                              },
                              attrs: { id: "summary" },
                              on: {
                                dragover: _vm.dragover,
                                dragleave: _vm.dragleave,
                                drop: _vm.drop,
                              },
                            },
                            [
                              _c("input", {
                                ref: "file",
                                staticClass:
                                  "w-px h-px opacity-0 overflow-hidden absolute",
                                attrs: {
                                  type: "file",
                                  multiple: "",
                                  name: "fields[assetsFieldHandle][]",
                                  id: "assetsFieldHandle",
                                  accept:
                                    ".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx",
                                },
                                on: { change: _vm.onChange },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "block cursor-pointer summary__filelist",
                                  attrs: { for: "assetsFieldHandle" },
                                },
                                [
                                  _c("div", { staticClass: "summary__label" }, [
                                    _vm._v("Прикрепите резюме *"),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "summary__desc" }, [
                                _vm._v(
                                  "Файл в формате PDF, DOC, DOCX, RTF, JPG"
                                ),
                              ]),
                              _vm._v(" "),
                              this.filelist.length
                                ? _c(
                                    "ul",
                                    { staticClass: "m-0" },
                                    _vm._l(
                                      _vm.filelist,
                                      function (file, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass:
                                              "text-sm p-1 text-left",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(file.name) +
                                                "\n                                        "
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "ml-2 summary__remove_file",
                                                attrs: {
                                                  type: "button",
                                                  title: "Remove file",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.remove(
                                                      _vm.filelist.indexOf(file)
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Удалить\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.fileError
                        ? _c("div", { staticClass: "summary__error-message" }, [
                            _vm._v(
                              "\n                            Загрузите файл\n                        "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-12 pb-3 px-3 pt-3" },
                    [
                      _c("div", {
                        staticClass: "w-100 mt-30",
                        class: _vm.captchaPassed ? "" : "error-captcha",
                        attrs: { id: "captcha-container" },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "formNew_wrap__item  mt-30" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              rules: [
                                function (v) {
                                  return !!v || "Обязательное поле"
                                },
                              ],
                              required: "",
                              color: "red",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                                        Я выражаю согласие с\n                                        "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0);",
                                              target: "_blank",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$refs.modal_contents_agree.modal_open(
                                                  "scroll_false"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            условиями использования\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                                        моих персональных данных для обработки данного обращения\n                                        ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,\n                                        г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю\n                                        согласие с\n                                        "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.policy },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(_vm.policy)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Политикой конфиденциальности\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " и\n                                        "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "position-relative zi-1",
                                            attrs: { href: _vm.agreement },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkOpen(
                                                  _vm.agreement
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Пользовательским соглашением."
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.checkbox,
                              callback: function ($$v) {
                                _vm.checkbox = $$v
                              },
                              expression: "checkbox",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-checkbox", {
                            staticClass: "mt-0",
                            attrs: { color: "red" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "customLabelForm" },
                                      [
                                        _vm._v(
                                          "\n                                        Я выражаю согласие на информирование меня о продуктах, акциях, выгодных\n                                        предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:\n                                        141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,\n                                        этаж 2) и\n                                        партнеров.\n                                    "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.consentToInform,
                              callback: function ($$v) {
                                _vm.consentToInform = $$v
                              },
                              expression: "consentToInform",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: " d-flex align-items-center  " },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn-red w-mc",
                                  attrs: { disabled: !_vm.valid },
                                  on: { click: _vm.sendForm },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Отправить\n                                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }